module.exports = __webpack_public_path__ + "img/espacamento_entre_perfis.4ed162ce.png";